import { BlockEditProps } from "@wordpress/blocks";
import React, { useCallback } from "react";
import Select from "react-select";
import Creatable from "react-select/creatable";
import type { BlockAttributes } from "./block.json";
import {
  InspectorControls,
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import "../slider/swiper";
import ImageEditor from "../../../source/components/ImageEditor";

export default function ParallaxEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "" });

  return (
    <>
      <div {...blockProps}>
        <h2>This is a Parallax Section</h2>
      </div>
    </>
  );
}
